import {useHistory, useRouteMatch} from "react-router";
import React, {useEffect, useRef, useState} from "react";
import {useArticulosService, usePedidosService, usePickingService} from "services/hooks";
import {useSnackbar} from "notistack";
import {Button, Divider} from "@material-ui/core/index";
import {CardArticulo} from "components/picking/ValidarDespachoPedido/card.articulo";
import {CardHeader} from "components/picking/components/card.header";
import {useConfirm} from 'material-ui-confirm';
import Box from "@material-ui/core/Box";
import {ItemActionsDialog} from "components/picking/ValidarDespachoPedido/item.actions.dialog";
import {ScanErrorDialog} from "components/picking/ValidarDespachoPedido/scan.error.dialog";
import {ScanSuccessPopover} from "components/picking/ValidarDespachoPedido/scan.success.popover";
import {ClickAwayListener, Typography} from "@material-ui/core";
import {ScanReceptor} from "components/picking/components/scan.receptor";
import {removeArticulosEspeciales} from "../../../assets/utils";
import {ManualScan} from "../components/manual.scan";
import {PickingService} from "../../../services";

export function ScanArticulosView() {
    const [articulos, _setArticulos] = useState([]);
    const [scanResult, setScanResult] = useState({errorDialogOpen: false, successPopoverOpen: false, found: false, articulo: undefined});
    const [itemActions, setItemActions] = useState({dialogOpen: false, articulo: undefined});
    const scanActive = useRef(true);

    const history = useHistory();
    const match = useRouteMatch();
    const {enqueueSnackbar} = useSnackbar();
    const confirm = useConfirm();
    const PedidosService = usePedidosService();
    const ArticulosService = useArticulosService();
    const PickingService = usePickingService();

    const articulosRef = React.useRef(articulos);

    const setArticulos = articulos => {
        const _articulos = [];
        articulos.forEach(articulo => {
            const existingArticulo = _articulos.find(_articulo => _articulo.id === articulo.id);
            if (!existingArticulo)
                _articulos.push({...articulo, cantidad: parseInt(articulo.cantidad), numrenglon: [articulo.numrenglon]});
            else {
                existingArticulo.cantidad += parseInt(articulo.cantidad);
                existingArticulo.numrenglon.push(articulo.numrenglon);
            }
        })

        articulosRef.current = _articulos;
        _setArticulos(_articulos);
    }

    useEffect(() => {
        PedidosService.getArticulosById(
            match.params.idPedido,
            response => setArticulos(removeArticulosEspeciales(response.data.result)),
            error => enqueueSnackbar(error, {variant: 'error'})
        );
    }, []);

    const findScannedArticulo = (scannedCode) => {
        return new Promise((resolve, reject) => {
            ArticulosService.getByBarcode(
                scannedCode,
                success => resolve(success.data.count > 0 ? success.data.result : undefined),
                error => enqueueSnackbar(error, {variant: 'error'})
            )
        })
    }

    const onScanCode = async (scannedCode) => {
        let scannedArticulo = await findScannedArticulo(scannedCode);
        scannedArticulo = articulosRef.current.find(articulo => (articulo.id === scannedArticulo?.id));

        if (scannedArticulo) {
            scannedArticulo.scanned = scannedArticulo.scanned ? parseInt(scannedArticulo.scanned) + 1 : 1;
            setArticulos(articulosRef.current);
        }

        setScanResult({
            errorDialogOpen: !scannedArticulo,
            successPopoverOpen: !!scannedArticulo,
            found: !!scannedArticulo,
            scannedCode: scannedCode,
            articulo: scannedArticulo
        });
    };

    const navBack = () => history.push(`/picking/validarDespachoPedido/${match.params.idHojaDeRuta}`);

    const onCancelValidation = () => {
        confirm({
            title: '¿Seguro de cancelar?',
            description: 'Si elige CANCELAR el pedido no se validará.',
            confirmationText: 'Si, cancelar',
            cancellationText: 'No, seguir'
        })
            .then(() => {
                navBack();
            })
            .catch(() => {
            });
    }

    const onFinishValidation = () => {
        const notWholeScanned = articulos.filter(articulo => !articulo.scanned || articulo.scanned < articulo.cantidad);

        const nothingScanned = articulos.every(articulo => !articulo.scanned);
        const tooMuchScanned = articulos.filter(articulo => articulo.scanned > articulo.cantidad);
        const someError = nothingScanned || tooMuchScanned.length > 0;

        confirm({
            dialogProps: {fullScreen: false},
            title: someError ? 'Errores en la validación' : '¿Seguro de terminar?',
            content: <>
                {tooMuchScanned.length > 0 &&
                    <Typography className={"mb-3"}>Hay <b>{tooMuchScanned.length}</b> artículos con demasiados escaneos.</Typography>
                }
                {nothingScanned &&
                    <Typography className={"mb-3"}>No se realizaron escaneos.</Typography>
                }
                {!nothingScanned && notWholeScanned.length > 0 &&
                    <Typography color={"primary"} className={"mb-3"}>
                        Hay <b>{notWholeScanned.length}</b> artículos con faltantes de escanear.
                        Si confirma, se modificarán las cantidades a despachar y quedarán pendientes en el pedido.
                    </Typography>
                }
                {someError ? (
                    <Typography color={"error"}>Hay errores en la validación y no se puede terminar, revise.</Typography>
                ) : (
                    <Typography>El pedido se marcará como validado y podrá ser despachado.</Typography>
                )}
            </>,
            confirmationText: 'Terminar',
            confirmationButtonProps: {disabled: someError},
            cancellationText: 'Cancelar'
        })
            .then(() => {
                // Marcar pedido como validado y marcar faltantes
                // if (notWholeScanned.length > 0) {
                //     notWholeScanned.forEach(articulo => {
                //         articulo.numrenglon.forEach(renglon => {
                //
                //         });
                //     });
                // }

                PickingService.validatePedido(
                    match.params.idPedido,
                    response => navBack(),
                    error => enqueueSnackbar(error, {variant: 'error'})
                );
            })
            .catch(() => {
            });
    }

    const closeErrorDialog = () => setScanResult(prev => ({...prev, errorDialogOpen: false}));
    const closeSuccessPopover = () => setScanResult(prev => ({...prev, successPopoverOpen: false}));

    const closeItemActionsDialog = () => setItemActions(prev => ({...prev, dialogOpen: false}));

    const onClickArticulo = (articulo) => {
        setItemActions({dialogOpen: true, articulo: articulo});
    };

    const completeScans = articulo => {
        articulo.scanned = parseInt(articulo.cantidad);
        setItemActions(prevItemsActions => ({...prevItemsActions, articulo}));
        setArticulos(articulos);
    }

    const deleteScans = articulo => {
        articulo.scanned = 0;
        setItemActions(prevItemsActions => ({...prevItemsActions, articulo}));
        setArticulos(articulos);
    }

    return (
        <>
            <ScanReceptor onScanCode={onScanCode} scanActive={scanActive}/>
            <div style={{height: window.innerHeight - 47, overflowY: 'auto'}}>
                <CardHeader
                    textLeft={<>Hoja: <b>{match.params.idHojaDeRuta}</b></>}
                    textRight={
                        <>
                            <b>{articulos.length}</b> artículos
                            <ManualScan onScanCode={onScanCode} scanActive={scanActive}/>
                        </>
                    }
                    textLeftBottom={<>Pedido: <b>{match.params.idPedido}</b></>}
                />
                {articulos.map((articulo, index) =>
                    <>
                        <CardArticulo
                            key={index}
                            id={articulo.id}
                            detalle={articulo.detalle}
                            cantidad={articulo.cantidad}
                            scanned={articulo.scanned}
                            onClick={() => {
                                onClickArticulo(articulo);
                            }}
                        />
                        {index !== articulos.length - 1 && (
                            <Divider/>
                        )}
                    </>
                )}

                <Box>
                    <Button
                        size={"medium"}
                        variant={"contained"}
                        className={'mt-2 mb-2'}
                        // disableElevation
                        color={"primary"}
                        // fullWidth
                        style={{width: '90%', height: '3.5rem', margin: '0 5%'}}
                        onClick={() => {
                            onFinishValidation()
                        }}
                    >
                        Terminar
                    </Button>
                    <Button
                        size={"medium"}
                        variant={"contained"}
                        // disableElevation
                        className={'mt-2 mb-2'}
                        color={"error"}
                        // fullWidth
                        style={{width: '90%', height: '3.5rem', margin: '0 5%'}}
                        onClick={() => {
                            onCancelValidation()
                        }}
                    >
                        Cancelar
                    </Button>
                </Box>
            </div>


            {scanResult.successPopoverOpen && (
                <ClickAwayListener onClickAway={() => closeSuccessPopover()}>
                    <Box>
                        <ScanSuccessPopover
                            open={scanResult.successPopoverOpen}
                            articulo={scanResult.articulo}
                            fullScreen
                            onClick={() => onClickArticulo(scanResult.articulo)}
                            onClose={(e) => {
                                e.stopPropagation();
                                closeSuccessPopover();
                            }}
                            confirmText={'Cerrar'}
                        />
                    </Box>
                </ClickAwayListener>
            )}

            <ScanErrorDialog
                open={scanResult.errorDialogOpen}
                scanResult={scanResult}
                fullScreen
                onConfirm={() => {
                    closeErrorDialog()
                }}
                confirmText={'Cerrar'}
            />

            <ItemActionsDialog
                open={itemActions.dialogOpen}
                articulo={itemActions.articulo}
                fullScreen
                onCompleteScans={() => {
                    closeItemActionsDialog();
                    completeScans(itemActions.articulo);
                }}
                onDeleteScans={() => {
                    closeItemActionsDialog();
                    deleteScans(itemActions.articulo);
                }}
                onCancel={() => closeItemActionsDialog()}
                confirmText={'Cerrar'}
            />
        </>
    )
}
